import { createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, withModifiers as _withModifiers, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from './questionList/svg/workflow.svg'
import _imports_1 from './svg/arrow-down.svg'
import _imports_2 from './svg/arrow-right.svg'
import _imports_3 from '@/assets/images/download.svg'
import _imports_4 from './svg/workflow-preview.svg'
import _imports_5 from '@/assets/images/upload.svg'

const _withId = /*#__PURE__*/_withScopeId("data-v-27107cf4")

_pushScopeId("data-v-27107cf4")
const _hoisted_1 = {
  class: "ticket-detail",
  id: "ticket-detail"
}
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" / ")
const _hoisted_3 = /*#__PURE__*/_createVNode("h2", null, "工单时间修改", -1)
const _hoisted_4 = { class: "body" }
const _hoisted_5 = {
  key: 0,
  class: "workflow-display"
}
const _hoisted_6 = /*#__PURE__*/_createVNode("img", { src: _imports_0 }, null, -1)
const _hoisted_7 = /*#__PURE__*/_createVNode("span", null, "工作流", -1)
const _hoisted_8 = { style: {"display":"inline-block","justify-content":"center","align-items":"center","width":"16px","height":"6px"} }
const _hoisted_9 = {
  key: 0,
  src: _imports_1,
  style: {"position":"relative","top":"-2px"},
  alt: ""
}
const _hoisted_10 = {
  key: 1,
  src: _imports_2,
  alt: ""
}
const _hoisted_11 = /*#__PURE__*/_createVNode("p", null, "已变更", -1)
const _hoisted_12 = { class: "template-list" }
const _hoisted_13 = { class: "template-title" }
const _hoisted_14 = /*#__PURE__*/_createVNode("p", null, "使用中", -1)
const _hoisted_15 = { style: {"display":"flex","justify-content":"space-between"} }
const _hoisted_16 = {
  key: 0,
  class: "jinji"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode("转至工单详情")
const _hoisted_18 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-right" }, null, -1)
const _hoisted_19 = { class: "transaction transaction-line" }
const _hoisted_20 = /*#__PURE__*/_createVNode("span", { class: "text-r" }, "客户描述:", -1)
const _hoisted_21 = { class: "comment" }
const _hoisted_22 = {
  key: 0,
  class: "transaction transaction-line"
}
const _hoisted_23 = /*#__PURE__*/_createVNode("span", { class: "text-r" }, "工单描述:", -1)
const _hoisted_24 = { class: "comment" }
const _hoisted_25 = { class: "file-name" }
const _hoisted_26 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_27 = /*#__PURE__*/_createVNode("span", null, "收起", -1)
const _hoisted_28 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-up" }, null, -1)
const _hoisted_29 = /*#__PURE__*/_createVNode("span", null, "展开", -1)
const _hoisted_30 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down" }, null, -1)
const _hoisted_31 = {
  key: 1,
  class: "attach-img-box"
}
const _hoisted_32 = {
  key: 2,
  class: "extra-tags"
}
const _hoisted_33 = { key: 0 }
const _hoisted_34 = {
  class: "transaction transaction-line",
  style: {"border-bottom":"1px solid #f3f5f6","padding-bottom":"24px"}
}
const _hoisted_35 = /*#__PURE__*/_createVNode("span", { class: "text-r" }, "紧急程度:", -1)
const _hoisted_36 = { class: "comment" }
const _hoisted_37 = { class: "max-img" }
const _hoisted_38 = { class: "transaction transaction-line" }
const _hoisted_39 = /*#__PURE__*/_createVNode("span", {
  class: "action closed",
  style: {"margin-right":"-8px"}
}, "创建问题", -1)
const _hoisted_40 = { class: "text-r" }
const _hoisted_41 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_42 = { class: "color-35 mt8" }
const _hoisted_43 = /*#__PURE__*/_createVNode("span", { class: "comment" }, null, -1)
const _hoisted_44 = { class: "transaction transaction-line" }
const _hoisted_45 = /*#__PURE__*/_createVNode("span", {
  class: "action",
  style: {"margin-right":"-8px"}
}, "创建工单", -1)
const _hoisted_46 = { class: "text-r" }
const _hoisted_47 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_48 = { class: "color-35 mt8" }
const _hoisted_49 = /*#__PURE__*/_createVNode("span", { class: "comment" }, null, -1)
const _hoisted_50 = { class: "cost-time" }
const _hoisted_51 = { class: "transaction transaction-line" }
const _hoisted_52 = {
  key: 0,
  class: "action closed"
}
const _hoisted_53 = {
  key: 1,
  class: "action change-t"
}
const _hoisted_54 = {
  key: 2,
  class: "action delayed-status"
}
const _hoisted_55 = {
  key: 3,
  class: "action restart-status"
}
const _hoisted_56 = {
  key: 4,
  class: "action empty"
}
const _hoisted_57 = {
  key: 5,
  class: "operator"
}
const _hoisted_58 = { class: "text-r" }
const _hoisted_59 = {
  key: 0,
  style: {"margin":"0 4px"}
}
const _hoisted_60 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_61 = { class: "color-35 mt8" }
const _hoisted_62 = { style: {"display":"inline-block","min-width":"140px","text-align":"right"} }
const _hoisted_63 = { key: 0 }
const _hoisted_64 = { key: 1 }
const _hoisted_65 = {
  key: 0,
  style: {"margin":"0 4px"}
}
const _hoisted_66 = {
  key: 7,
  class: "comment"
}
const _hoisted_67 = { class: "file-name" }
const _hoisted_68 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_69 = /*#__PURE__*/_createVNode("span", null, "收起", -1)
const _hoisted_70 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-up" }, null, -1)
const _hoisted_71 = /*#__PURE__*/_createVNode("span", null, "展开", -1)
const _hoisted_72 = /*#__PURE__*/_createVNode("i", { class: "el-icon-arrow-down" }, null, -1)
const _hoisted_73 = {
  key: 1,
  class: "attach-img-box"
}
const _hoisted_74 = {
  key: 2,
  class: "extra-tags"
}
const _hoisted_75 = { key: 0 }
const _hoisted_76 = {
  key: 8,
  class: "cost-time"
}
const _hoisted_77 = { class: "transaction transaction-line" }
const _hoisted_78 = /*#__PURE__*/_createVNode("span", { class: "action" }, "继续", -1)
const _hoisted_79 = { class: "text-r" }
const _hoisted_80 = /*#__PURE__*/_createVNode("br", null, null, -1)
const _hoisted_81 = { key: 0 }
const _hoisted_82 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_83 = /*#__PURE__*/_createVNode("span", { class: "label" }, "预览图", -1)
const _hoisted_84 = /*#__PURE__*/_createVNode("img", { src: _imports_5 }, null, -1)
const _hoisted_85 = /*#__PURE__*/_createVNode("span", null, "上传附件", -1)
const _hoisted_86 = {
  key: 0,
  class: "file-list-box"
}
const _hoisted_87 = /*#__PURE__*/_createVNode("img", { src: _imports_3 }, null, -1)
const _hoisted_88 = /*#__PURE__*/_createTextVNode("删除")
const _hoisted_89 = {
  class: "attach-img-box",
  style: {"width":"100%"}
}
const _hoisted_90 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_91 = /*#__PURE__*/_createTextVNode("挂起")
const _hoisted_92 = /*#__PURE__*/_createTextVNode("继续")
const _hoisted_93 = /*#__PURE__*/_createTextVNode("已解决")
const _hoisted_94 = {
  key: 1,
  class: "btn-box2"
}
const _hoisted_95 = {
  key: 0,
  class: "liu-cheng-info"
}
const _hoisted_96 = /*#__PURE__*/_createTextVNode("当前节点： ")
const _hoisted_97 = { class: "nodeItem" }
const _hoisted_98 = /*#__PURE__*/_createVNode("span", null, "|", -1)
const _hoisted_99 = /*#__PURE__*/_createVNode("img", { src: _imports_4 }, null, -1)
const _hoisted_100 = /*#__PURE__*/_createTextVNode("预览图")
const _hoisted_101 = { key: 1 }
const _hoisted_102 = /*#__PURE__*/_createTextVNode("返回")
const _hoisted_103 = /*#__PURE__*/_createTextVNode("确认")
const _hoisted_104 = /*#__PURE__*/_createTextVNode("关联Jira")
const _hoisted_105 = /*#__PURE__*/_createTextVNode("认领")
const _hoisted_106 = /*#__PURE__*/_createTextVNode("重启工单")
const _hoisted_107 = /*#__PURE__*/_createTextVNode("直接关闭")
const _hoisted_108 = {
  key: 0,
  class: "detial-show-tickets"
}
const _hoisted_109 = { class: "title" }
const _hoisted_110 = /*#__PURE__*/_createVNode("span", null, "请填写以下字段此工单将进入JIRA:", -1)
const _hoisted_111 = { class: "select" }
const _hoisted_112 = /*#__PURE__*/_createVNode("i", null, "*", -1)
const _hoisted_113 = /*#__PURE__*/_createVNode("span", { class: "label" }, " JIRA项目： ", -1)
const _hoisted_114 = { class: "select" }
const _hoisted_115 = /*#__PURE__*/_createVNode("i", null, "*", -1)
const _hoisted_116 = /*#__PURE__*/_createVNode("span", { class: "label" }, " 故障发生环境： ", -1)
const _hoisted_117 = {
  key: 0,
  class: "select"
}
const _hoisted_118 = /*#__PURE__*/_createVNode("i", null, "*", -1)
const _hoisted_119 = /*#__PURE__*/_createVNode("span", { class: "label" }, " 处理人： ", -1)
const _hoisted_120 = { class: "phase-select-dialog" }
const _hoisted_121 = /*#__PURE__*/_createVNode("div", { class: "title" }, "请选择工作流节点", -1)
const _hoisted_122 = { class: "content" }
const _hoisted_123 = /*#__PURE__*/_createVNode("div", { class: "label" }, "处理节点：", -1)
const _hoisted_124 = { class: "button-area" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_Breadcrumb = _resolveComponent("Breadcrumb")
  const _component_el_input = _resolveComponent("el-input")
  const _component_template_generator = _resolveComponent("template-generator")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_link = _resolveComponent("el-link")
  const _component_el_image = _resolveComponent("el-image")
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_timeline_item = _resolveComponent("el-timeline-item")
  const _component_el_timeline = _resolveComponent("el-timeline")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_upload = _resolveComponent("el-upload")
  const _component_TinymceEditor = _resolveComponent("TinymceEditor")
  const _component_el_form = _resolveComponent("el-form")
  const _component_el_tooltip = _resolveComponent("el-tooltip")
  const _component_TicketAddTag = _resolveComponent("TicketAddTag")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_TicketTemplateChange = _resolveComponent("TicketTemplateChange")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode(_component_Breadcrumb, null, {
      default: _withId(() => [
        _createVNode("span", null, [
          _createVNode("a", {
            href: "javascript:void(0)",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.$router.back()))
          }, "工单视图"),
          _hoisted_2
        ]),
        _hoisted_3
      ]),
      _: 1
    }),
    _createVNode("div", _hoisted_4, [
      _createVNode("div", null, [
        (_ctx.workflowId)
          ? (_openBlock(), _createBlock("div", _hoisted_5, [
              _hoisted_6,
              _hoisted_7,
              _createVNode(_component_el_input, {
                "model-value": _ctx.workflowName,
                disabled: ""
              }, null, 8, ["model-value"])
            ]))
          : _createCommentVNode("", true),
        _createVNode("div", null, [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.templateUsedRecord, (t, index) => {
            return (_openBlock(), _createBlock("div", {
              class: "record-template",
              key: index
            }, [
              _createVNode("div", {
                class: "template-title",
                onClick: ($event: any) => (t.showItemTemplate = !t.showItemTemplate)
              }, [
                _createVNode("p", null, [
                  _createVNode("span", _hoisted_8, [
                    (t.showItemTemplate)
                      ? (_openBlock(), _createBlock("img", _hoisted_9))
                      : (_openBlock(), _createBlock("img", _hoisted_10))
                  ]),
                  _createVNode("span", null, _toDisplayString(t?.template?.fields?.name), 1)
                ]),
                _hoisted_11
              ], 8, ["onClick"]),
              (Object.keys(t?.template?.fields?.template).length > 0 && t.showItemTemplate)
                ? (_openBlock(), _createBlock(_component_template_generator, {
                    key: 0,
                    disabled: true,
                    "template-data": t?.template?.fields?.template,
                    value: t.fieldInfo,
                    "onUpdate:value": ($event: any) => (t.fieldInfo = $event)
                  }, null, 8, ["template-data", "value", "onUpdate:value"]))
                : _createCommentVNode("", true)
            ]))
          }), 128)),
          _createVNode("div", _hoisted_12, [
            _createVNode("div", _hoisted_13, [
              _createVNode("p", null, _toDisplayString(_ctx.currentTemplateInfo.template?.fields?.name || ''), 1),
              _hoisted_14
            ]),
            (Object.keys(_ctx.template).length > 0)
              ? (_openBlock(), _createBlock(_component_template_generator, {
                  key: 0,
                  disabled: !_ctx.isHandleable && !_ctx.isEditable,
                  ref: "templateGenerator",
                  "template-data": _ctx.template,
                  value: _ctx.templateValue,
                  "onUpdate:value": _cache[2] || (_cache[2] = ($event: any) => (_ctx.templateValue = $event)),
                  onChange: _ctx.templateValueChange
                }, null, 8, ["disabled", "template-data", "value", "onChange"]))
              : _createCommentVNode("", true)
          ])
        ])
      ]),
      _createVNode("div", null, [
        _createVNode("div", _hoisted_15, [
          _createVNode("span", null, [
            _createVNode("span", null, _toDisplayString(_ctx.ticket?.pk) + " - " + _toDisplayString(_ctx.ticket.fields?.title), 1),
            (_ctx.ticket.fields?.urgentLevel < 5)
              ? (_openBlock(), _createBlock("span", _hoisted_16, "紧急"))
              : _createCommentVNode("", true)
          ]),
          _createVNode(_component_el_button, {
            type: "primary",
            plain: "",
            onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$router.push({name: '工单详情',query: { id: _ctx.ticket?.pk }}))),
            style: {"margin-left":"8px"}
          }, {
            default: _withId(() => [
              _hoisted_17,
              _hoisted_18
            ]),
            _: 1
          })
        ]),
        _createVNode("div", null, [
          _createVNode("div", _hoisted_19, [
            _hoisted_20,
            _createVNode("span", _hoisted_21, [
              _createVNode("span", {
                class: "max-img",
                innerHTML: _ctx.ticket.fields?.problem?.fields?.problemDescribe
              }, null, 8, ["innerHTML"])
            ])
          ]),
          (_ctx.ticketDesc)
            ? (_openBlock(), _createBlock("div", _hoisted_22, [
                _hoisted_23,
                _createVNode("span", _hoisted_24, [
                  _createVNode("span", {
                    class: "max-img",
                    innerHTML: _ctx.displayNewline(_ctx.ticketDesc.record.comment)
                  }, null, 8, ["innerHTML"]),
                  (_ctx.notImageList(_ctx.ticketDesc.record.attachments).length > 0)
                    ? (_openBlock(), _createBlock("div", {
                        key: 0,
                        class: ["attachments ", {
                    opened: _ctx.ticketDesc.attachmentsOpened
                  }]
                      }, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.notImageList(_ctx.ticketDesc.record.attachments) || [], (am, i) => {
                          return (_openBlock(), _createBlock("div", {
                            key: am.key,
                            class: "am"
                          }, [
                            _createVNode("div", null, [
                              _createVNode("span", _hoisted_25, _toDisplayString(am.name), 1),
                              _createVNode(_component_el_link, {
                                class: "file-download",
                                href: am.url,
                                target: "_blank"
                              }, {
                                default: _withId(() => [
                                  _hoisted_26
                                ]),
                                _: 2
                              }, 1032, ["href"])
                            ]),
                            (_ctx.notImageList(_ctx.ticketDesc.record.attachments).length > 1 && i === 0)
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: "right-btn",
                                  onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.ticketDesc.attachmentsOpened = !_ctx.ticketDesc.attachmentsOpened))
                                }, [
                                  (_ctx.ticketDesc.attachmentsOpened)
                                    ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                        _hoisted_27,
                                        _hoisted_28
                                      ], 64))
                                    : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                        _hoisted_29,
                                        _hoisted_30
                                      ], 64))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ], 2))
                    : _createCommentVNode("", true),
                  (_ctx.imageList(_ctx.ticketDesc.record.attachments).length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_31, [
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imageList(_ctx.ticketDesc.record.attachments), (file) => {
                          return (_openBlock(), _createBlock(_Fragment, null, [
                            (_ctx.checkImage(file.name))
                              ? (_openBlock(), _createBlock("div", {
                                  key: file.key,
                                  class: "img-div"
                                }, [
                                  _createVNode(_component_el_image, {
                                    src: file.url,
                                    "preview-src-list": [file.url],
                                    style: {"width":"100px","height":"80px"}
                                  }, null, 8, ["src", "preview-src-list"])
                                ]))
                              : _createCommentVNode("", true)
                          ], 64))
                        }), 256))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.ticketDesc.record.extraTags?.length > 0)
                    ? (_openBlock(), _createBlock("div", _hoisted_32, [
                        _createVNode("span", null, "L" + _toDisplayString(_ctx.ticketDesc.phaseId) + "-" + _toDisplayString(_ctx.ticketDesc.operatorName) + " | 添加了标签：", 1),
                        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.ticketDesc.record.extraTags, (t, i) => {
                          return (_openBlock(), _createBlock("span", {
                            key: t.id
                          }, [
                            _createVNode("span", null, _toDisplayString(t.name), 1),
                            (i !== _ctx.ticketDesc.record.extraTags.length - 1)
                              ? (_openBlock(), _createBlock("span", _hoisted_33, "、"))
                              : _createCommentVNode("", true)
                          ]))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true)
                ])
              ]))
            : _createCommentVNode("", true),
          _createVNode("div", _hoisted_34, [
            _hoisted_35,
            _createVNode("span", _hoisted_36, [
              _createVNode("span", _hoisted_37, _toDisplayString(_ctx.ticket.fields?.urgentLevel), 1)
            ])
          ]),
          _createVNode(_component_el_timeline, null, {
            default: _withId(() => [
              _createVNode(_component_el_timeline_item, null, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_38, [
                    _hoisted_39,
                    _createVNode("span", _hoisted_40, [
                      _createTextVNode(_toDisplayString(_ctx.ticketOr(_ctx.ticket.fields?.problem?.fields)), 1),
                      _hoisted_41,
                      _createVNode("span", _hoisted_42, [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.problemCreateTime,
                          "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.problemCreateTime = $event)),
                          class: "date-select",
                          type: "datetime",
                          onChange: _ctx.updateProblemCreateTime,
                          "value-format": "timestamp"
                        }, null, 8, ["modelValue", "onChange"])
                      ])
                    ]),
                    _hoisted_43
                  ])
                ]),
                _: 1
              }),
              _createVNode(_component_el_timeline_item, null, {
                default: _withId(() => [
                  _createVNode("div", _hoisted_44, [
                    _hoisted_45,
                    _createVNode("span", _hoisted_46, [
                      _createTextVNode(_toDisplayString(_ctx.ticket.fields?.creatorName || _ctx.ticket.fields?.creator), 1),
                      _hoisted_47,
                      _createVNode("span", _hoisted_48, [
                        _createVNode(_component_el_date_picker, {
                          modelValue: _ctx.ticketCreateTime,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.ticketCreateTime = $event)),
                          class: "date-select",
                          type: "datetime",
                          onChange: _ctx.updateTicketCreateTime,
                          "value-format": "timestamp"
                        }, null, 8, ["modelValue", "onChange"])
                      ])
                    ]),
                    _hoisted_49,
                    _createVNode("span", _hoisted_50, _toDisplayString(_ctx.formatTime(_ctx.ticket.fields?.createdAt - _ctx.ticket.fields?.problem?.fields?.createTime)), 1)
                  ])
                ]),
                _: 1
              }),
              (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.transactions.slice(1), (transaction, index) => {
                return (_openBlock(), _createBlock(_component_el_timeline_item, {
                  class: {
              'middle': transaction.transactionType === 'claim' || transaction.transactionType === 'assign' || transaction.transactionType === 'redraw',
              'mb-24': transaction.transactionType === 'claim',
              'mt-24': transaction.transactionType === 'redraw',
            },
                  key: transaction.id
                }, {
                  default: _withId(() => [
                    _createVNode("div", _hoisted_51, [
                      (transaction.transactionType === 'finish')
                        ? (_openBlock(), _createBlock("span", _hoisted_52, "已解决"))
                        : (transaction.transactionType === 'change_template')
                          ? (_openBlock(), _createBlock("span", _hoisted_53, "变更"))
                          : (transaction.transactionType === 'suspend')
                            ? (_openBlock(), _createBlock("span", _hoisted_54, "挂起"))
                            : (transaction.transactionType === 'restart')
                              ? (_openBlock(), _createBlock("span", _hoisted_55, "重启"))
                              : (_openBlock(), _createBlock("span", _hoisted_56)),
                      (transaction.transactionType === 'finish' || transaction.transactionType === 'handle' || transaction.transactionType === 'change_template' || transaction.transactionType === 'suspend')
                        ? (_openBlock(), _createBlock("span", _hoisted_57, [
                            _createVNode("span", _hoisted_58, [
                              _createTextVNode(_toDisplayString(transaction.record?.notesComponents?.phaseName), 1),
                              (transaction.record?.notesComponents?.phaseName)
                                ? (_openBlock(), _createBlock("span", _hoisted_59, "-"))
                                : _createCommentVNode("", true),
                              _createTextVNode(_toDisplayString(transaction.record?.notesComponents?.agentName), 1),
                              _hoisted_60,
                              _createVNode("span", _hoisted_61, [
                                _createVNode(_component_el_date_picker, {
                                  modelValue: _ctx.transactions2[index].createdAt,
                                  "onUpdate:modelValue": ($event: any) => (_ctx.transactions2[index].createdAt = $event),
                                  class: "date-select",
                                  type: "datetime",
                                  onChange: ($event: any) => (_ctx.updateTxTime(transaction.id, index)),
                                  "value-format": "timestamp"
                                }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                              ])
                            ])
                          ]))
                        : (_openBlock(), _createBlock("div", {
                            key: 6,
                            class: ["operation-record", {'record-grey': transaction.transactionType === 'redraw', 'is-jira-go': transaction.transactionType === 'create_to_jira'}]
                          }, [
                            _createVNode("span", _hoisted_62, [
                              _createVNode(_component_el_date_picker, {
                                modelValue: _ctx.transactions2[index].createdAt,
                                "onUpdate:modelValue": ($event: any) => (_ctx.transactions2[index].createdAt = $event),
                                class: "date-select",
                                type: "datetime",
                                onChange: ($event: any) => (_ctx.updateTxTime(transaction.id, index)),
                                "value-format": "timestamp"
                              }, null, 8, ["modelValue", "onUpdate:modelValue", "onChange"])
                            ]),
                            (transaction.record?.notes)
                              ? (_openBlock(), _createBlock("span", _hoisted_63, _toDisplayString(transaction.record?.notes), 1))
                              : (_openBlock(), _createBlock("span", _hoisted_64, [
                                  _createTextVNode(_toDisplayString(transaction.record?.notesComponents?.phaseName), 1),
                                  (transaction.record?.notesComponents?.phaseName)
                                    ? (_openBlock(), _createBlock("span", _hoisted_65, "-"))
                                    : _createCommentVNode("", true),
                                  _createTextVNode(_toDisplayString(transaction.record?.notesComponents?.agentName), 1)
                                ])),
                            _createVNode("span", null, _toDisplayString(transaction.record?.comment), 1)
                          ], 2)),
                      (transaction.transactionType === 'finish' || transaction.transactionType === 'handle' || transaction.transactionType === 'change_template' || transaction.transactionType === 'suspend')
                        ? (_openBlock(), _createBlock("span", _hoisted_66, [
                            _createVNode("span", {
                              class: ["max-img", {'change-text': transaction.transactionType === 'change_template', 'delayed-text': transaction.transactionType === 'delayed'}],
                              innerHTML: transaction.record.comment
                            }, null, 10, ["innerHTML"]),
                            (_ctx.notImageList(transaction.record.attachments).length > 0)
                              ? (_openBlock(), _createBlock("div", {
                                  key: 0,
                                  class: [{
                    opened: transaction.attachmentsOpened
                  }, "attachments "]
                                }, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.notImageList(transaction.record.attachments) || [], (am, i) => {
                                    return (_openBlock(), _createBlock("div", {
                                      key: am.key,
                                      class: "am"
                                    }, [
                                      _createVNode("div", null, [
                                        _createVNode("span", _hoisted_67, _toDisplayString(am.name), 1),
                                        _createVNode(_component_el_link, {
                                          class: "file-download",
                                          href: am.url,
                                          target: "_blank"
                                        }, {
                                          default: _withId(() => [
                                            _hoisted_68
                                          ]),
                                          _: 2
                                        }, 1032, ["href"])
                                      ]),
                                      (_ctx.notImageList(transaction.record.attachments).length > 1 && i === 0)
                                        ? (_openBlock(), _createBlock("div", {
                                            key: 0,
                                            class: "right-btn",
                                            onClick: ($event: any) => (transaction.attachmentsOpened = !transaction.attachmentsOpened)
                                          }, [
                                            (transaction.attachmentsOpened)
                                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                                  _hoisted_69,
                                                  _hoisted_70
                                                ], 64))
                                              : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                                                  _hoisted_71,
                                                  _hoisted_72
                                                ], 64))
                                          ], 8, ["onClick"]))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ], 2))
                              : _createCommentVNode("", true),
                            (_ctx.imageList(transaction.record.attachments).length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_73, [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.imageList(transaction.record.attachments), (file) => {
                                    return (_openBlock(), _createBlock(_Fragment, null, [
                                      (_ctx.checkImage(file.name))
                                        ? (_openBlock(), _createBlock("div", {
                                            key: file.key,
                                            class: "img-div"
                                          }, [
                                            _createVNode(_component_el_image, {
                                              src: file.url,
                                              "preview-src-list": [file.url],
                                              style: {"width":"100px","height":"80px"}
                                            }, null, 8, ["src", "preview-src-list"])
                                          ]))
                                        : _createCommentVNode("", true)
                                    ], 64))
                                  }), 256))
                                ]))
                              : _createCommentVNode("", true),
                            (transaction.record.extraTags?.length > 0)
                              ? (_openBlock(), _createBlock("div", _hoisted_74, [
                                  _createVNode("span", null, _toDisplayString(transaction.record?.notesComponents?.phaseName) + " - " + _toDisplayString(transaction.record?.notesComponents?.agentName) + " | 添加了标签：", 1),
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(transaction.record.extraTags, (t, i) => {
                                    return (_openBlock(), _createBlock("span", {
                                      key: t.id
                                    }, [
                                      _createVNode("span", null, _toDisplayString(t.name), 1),
                                      (i !== transaction.record.extraTags.length - 1)
                                        ? (_openBlock(), _createBlock("span", _hoisted_75, "、"))
                                        : _createCommentVNode("", true)
                                    ]))
                                  }), 128))
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true),
                      (transaction.transactionType === 'finish' || transaction.transactionType === 'handle')
                        ? (_openBlock(), _createBlock("span", _hoisted_76, _toDisplayString((_ctx.transactions[index+1]?.createdAt - _ctx.transactions[index]?.createdAt) ? _ctx.formatTime(_ctx.transactions[index+1].createdAt - _ctx.transactions[index].createdAt) : ''), 1))
                        : _createCommentVNode("", true)
                    ])
                  ]),
                  _: 2
                }, 1032, ["class"]))
              }), 128)),
              (_ctx.ticket.fields?.curStatus === 'pending' && (_ctx.transactions[_ctx.transactions.length - 1].transactionType !== 'suspend'))
                ? (_openBlock(), _createBlock(_component_el_timeline_item, {
                    key: 0,
                    class: {'mt24':_ctx.transactions[_ctx.transactions.length - 1].transactionType === 'claim'}
                  }, {
                    default: _withId(() => [
                      _createVNode("div", _hoisted_77, [
                        _hoisted_78,
                        _createVNode("span", _hoisted_79, [
                          _createTextVNode(_toDisplayString(_ctx.ticket.fields?.responsibleAgentName), 1),
                          _hoisted_80
                        ])
                      ])
                    ]),
                    _: 1
                  }, 8, ["class"]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          })
        ]),
        (_ctx.isHandleable)
          ? (_openBlock(), _createBlock("div", _hoisted_81, [
              _createVNode(_component_el_form, {
                model: _ctx.ruleForm,
                rules: _ctx.rules,
                ref: "ruleFormRef"
              }, {
                default: _withId(() => [
                  _createVNode("div", null, [
                    (_ctx.workflowId)
                      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_el_form_item, {
                            label: "当前节点：",
                            prop: "nextProcess"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.selectedPhase,
                                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.selectedPhase = $event)),
                                "default-first-option": "",
                                onChange: _ctx.handlePhaseChange
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.processablePhases, (l) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: l.phaseId,
                                      value: l.phaseId,
                                      label: l.phaseName
                                    }, null, 8, ["value", "label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.taskVariables, (v, k) => {
                            return (_openBlock(), _createBlock(_component_el_form_item, {
                              label: "通过：",
                              key: k
                            }, {
                              default: _withId(() => [
                                _createVNode(_component_el_select, {
                                  modelValue: _ctx.taskVariables[k],
                                  "onUpdate:modelValue": ($event: any) => (_ctx.taskVariables[k] = $event),
                                  "default-first-option": ""
                                }, {
                                  default: _withId(() => [
                                    _createVNode(_component_el_option, {
                                      value: "true",
                                      label: "是"
                                    }),
                                    _createVNode(_component_el_option, {
                                      value: "false",
                                      label: "否"
                                    })
                                  ]),
                                  _: 2
                                }, 1032, ["modelValue", "onUpdate:modelValue"])
                              ]),
                              _: 2
                            }, 1024))
                          }), 128)),
                          _createVNode("div", {
                            class: "option-suffix",
                            onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.previewDialogVisible = true), ["stop"]))
                          }, [
                            _hoisted_82,
                            _hoisted_83
                          ])
                        ], 64))
                      : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
                          _createVNode(_component_el_form_item, {
                            label: "下一阶段：",
                            prop: "nextProcess"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                modelValue: _ctx.ruleForm.nextProcess,
                                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.ruleForm.nextProcess = $event)),
                                onChange: _ctx.changeNextProcess,
                                placeholder: "请选择"
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.processLabels, (l) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: l.id,
                                      value: l.id,
                                      label: l.name
                                    }, null, 8, ["value", "label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue", "onChange"])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_el_form_item, {
                            label: "处理人：",
                            prop: "nextHandler"
                          }, {
                            default: _withId(() => [
                              _createVNode(_component_el_select, {
                                clearable: "",
                                modelValue: _ctx.ruleForm.nextHandler,
                                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.ruleForm.nextHandler = $event)),
                                placeholder: "请选择",
                                filterable: ""
                              }, {
                                default: _withId(() => [
                                  (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.handlers, (p) => {
                                    return (_openBlock(), _createBlock(_component_el_option, {
                                      key: p.id,
                                      value: p.ldap,
                                      label: p.name
                                    }, {
                                      default: _withId(() => [
                                        _createTextVNode(_toDisplayString(p.name) + "（" + _toDisplayString(p.ldap) + "）", 1)
                                      ]),
                                      _: 2
                                    }, 1032, ["value", "label"]))
                                  }), 128))
                                ]),
                                _: 1
                              }, 8, ["modelValue"])
                            ]),
                            _: 1
                          })
                        ], 64)),
                    _createVNode(_component_el_upload, {
                      multiple: "",
                      "show-file-list": false,
                      ref: "fileUploader",
                      class: "upload-file",
                      "http-request": _ctx.uploadFile,
                      "on-preview": _ctx.handlePreview,
                      "on-remove": _ctx.handleRemove
                    }, {
                      default: _withId(() => [
                        _withDirectives(_createVNode(_component_el_button, {
                          class: "upload-btn",
                          size: "small"
                        }, {
                          default: _withId(() => [
                            _hoisted_84,
                            _hoisted_85,
                            (_ctx.fileList.length > 0)
                              ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
                                  (_ctx.showUploadFileList)
                                    ? (_openBlock(), _createBlock("i", {
                                        key: 0,
                                        onClick: _cache[11] || (_cache[11] = _withModifiers(($event: any) => (_ctx.showUploadFileList = false), ["stop"])),
                                        class: "icon-arrow el-icon-arrow-up"
                                      }))
                                    : (_openBlock(), _createBlock("i", {
                                        key: 1,
                                        onClick: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.showUploadFileList = true), ["stop"])),
                                        class: "icon-arrow el-icon-arrow-down"
                                      }))
                                ], 64))
                              : _createCommentVNode("", true)
                          ]),
                          _: 1
                        }, 512), [
                          [
                            _directive_loading,
                            _ctx.uploading,
                            void 0,
                            {
                              fullscreen: true,
                              lock: true
                            }
                          ]
                        ]),
                        (_ctx.showUploadFileList && _ctx.notImageList(_ctx.fileList).length > 0)
                          ? (_openBlock(), _createBlock("div", _hoisted_86, [
                              _createVNode("ul", null, [
                                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileList, (f, i) => {
                                  return (_openBlock(), _createBlock(_Fragment, null, [
                                    (!_ctx.checkImage(f.name))
                                      ? (_openBlock(), _createBlock("li", {
                                          key: f.name
                                        }, [
                                          _createVNode("span", null, [
                                            _createVNode("span", null, _toDisplayString(f.name), 1),
                                            _createVNode(_component_el_link, {
                                              class: "file-download",
                                              href: f.url,
                                              onClick: _cache[13] || (_cache[13] = _withModifiers(() => {}, ["stop"])),
                                              target: "_blank"
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_87
                                              ]),
                                              _: 2
                                            }, 1032, ["href"])
                                          ]),
                                          _createVNode("span", null, [
                                            _createVNode(_component_el_button, {
                                              onClick: _withModifiers(($event: any) => (_ctx.fileList.splice(i, 1)), ["stop"]),
                                              type: "text"
                                            }, {
                                              default: _withId(() => [
                                                _hoisted_88
                                              ]),
                                              _: 2
                                            }, 1032, ["onClick"])
                                          ])
                                        ]))
                                      : _createCommentVNode("", true)
                                  ], 64))
                                }), 256))
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }, 8, ["http-request", "on-preview", "on-remove"])
                  ]),
                  _createVNode(_component_el_form_item, {
                    label: "问题回复：",
                    class: "tinymce-editor-wrap",
                    prop: "newReply"
                  }, {
                    default: _withId(() => [
                      _createVNode(_component_TinymceEditor, {
                        height: 240,
                        placeholder: "工单描述模板：比如什么时间，什么问题",
                        ref: "refTinymceEditor",
                        value: _ctx.ruleForm.newReply,
                        "onUpdate:value": _cache[14] || (_cache[14] = ($event: any) => (_ctx.ruleForm.newReply = $event))
                      }, null, 8, ["value"])
                    ]),
                    _: 1
                  }),
                  (_ctx.imageList(_ctx.fileList).length > 0)
                    ? (_openBlock(), _createBlock(_component_el_form_item, {
                        key: 0,
                        label: "附件:",
                        class: "tinymce-editor-wrap"
                      }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_89, [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.fileList, (file, i) => {
                              return (_openBlock(), _createBlock(_Fragment, null, [
                                (_ctx.checkImage(file.name))
                                  ? (_openBlock(), _createBlock("div", {
                                      key: file.key,
                                      class: "img-div"
                                    }, [
                                      _createVNode(_component_el_image, {
                                        src: file.url,
                                        "preview-src-list": [file.url],
                                        style: {"width":"100px","height":"80px"}
                                      }, null, 8, ["src", "preview-src-list"]),
                                      _createVNode("span", {
                                        class: "icon-del",
                                        onClick: ($event: any) => (_ctx.fileList.splice(i, 1))
                                      }, null, 8, ["onClick"])
                                    ]))
                                  : _createCommentVNode("", true)
                              ], 64))
                            }), 256))
                          ])
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true),
                  _createVNode("div", null, [
                    _createVNode(_component_el_button, {
                      class: "cancel-btn",
                      onClick: _cache[15] || (_cache[15] = ($event: any) => (_ctx.$router.back()))
                    }, {
                      default: _withId(() => [
                        _hoisted_90
                      ]),
                      _: 1
                    }),
                    (_ctx.transactions[_ctx.transactions.length - 1].transactionType !== 'suspend')
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 0,
                          class: "suspend-btn",
                          type: "warning",
                          onClick: _ctx.delayedProcess
                        }, {
                          default: _withId(() => [
                            _hoisted_91
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true),
                    _createVNode(_component_el_button, {
                      class: "continue-btn",
                      onClick: _cache[16] || (_cache[16] = ($event: any) => (_ctx.ticketContinue()))
                    }, {
                      default: _withId(() => [
                        _hoisted_92
                      ]),
                      _: 1
                    }),
                    (!_ctx.workflowId)
                      ? (_openBlock(), _createBlock(_component_el_button, {
                          key: 1,
                          class: "resolved-btn",
                          onClick: _ctx.ticketClose
                        }, {
                          default: _withId(() => [
                            _hoisted_93
                          ]),
                          _: 1
                        }, 8, ["onClick"]))
                      : _createCommentVNode("", true)
                  ])
                ]),
                _: 1
              }, 8, ["model", "rules"])
            ]))
          : (_openBlock(), _createBlock("div", _hoisted_94, [
              (_ctx.workflowId)
                ? (_openBlock(), _createBlock("div", _hoisted_95, [
                    _createVNode("span", null, [
                      _hoisted_96,
                      (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.workFlowCurrentStatus, (item) => {
                        return (_openBlock(), _createBlock(_component_el_tooltip, {
                          key: item.node,
                          content: item.name,
                          placement: "top"
                        }, {
                          default: _withId(() => [
                            _createVNode("span", _hoisted_97, _toDisplayString(item?.node), 1)
                          ]),
                          _: 2
                        }, 1032, ["content"]))
                      }), 128))
                    ]),
                    _hoisted_98,
                    _createVNode("span", {
                      onClick: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.previewDialogVisible = true), ["stop"])),
                      class: "preview"
                    }, [
                      _hoisted_99,
                      _hoisted_100
                    ])
                  ]))
                : (_openBlock(), _createBlock("div", _hoisted_101)),
              _createVNode("div", null, [
                _createVNode(_component_el_button, {
                  onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.$router.back()))
                }, {
                  default: _withId(() => [
                    _hoisted_102
                  ]),
                  _: 1
                }),
                (_ctx.relationJiraBtn)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: ["jira-class", {'is-none': _ctx.ticket.createToJira}],
                      disabled: _ctx.jiraButtonDiasable2,
                      onClick: _ctx.ticketRelationJira
                    }, {
                      default: _withId(() => [
                        _hoisted_103
                      ]),
                      _: 1
                    }, 8, ["class", "disabled", "onClick"]))
                  : (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      class: ["jira-class", {'is-none': _ctx.ticket.createToJira}],
                      onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.ticketContJira('relation')))
                    }, {
                      default: _withId(() => [
                        _hoisted_104
                      ]),
                      _: 1
                    }, 8, ["class"])),
                (_ctx.isClaimable)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 2,
                      type: "primary",
                      onClick: _ctx.assignMe
                    }, {
                      default: _withId(() => [
                        _hoisted_105
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isFinish)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 3,
                      class: "restart-class",
                      onClick: _ctx.restartTicket
                    }, {
                      default: _withId(() => [
                        _hoisted_106
                      ]),
                      _: 1
                    }, 8, ["onClick"]))
                  : _createCommentVNode("", true),
                (_ctx.isDirectClosable)
                  ? (_openBlock(), _createBlock(_component_el_tooltip, {
                      key: 4,
                      content: "工单创建者可以直接关闭工单",
                      placement: "top"
                    }, {
                      default: _withId(() => [
                        (_ctx.isDirectClosable)
                          ? (_openBlock(), _createBlock(_component_el_button, {
                              key: 0,
                              class: "close-class",
                              onClick: _ctx.ticketDirectClose
                            }, {
                              default: _withId(() => [
                                _hoisted_107
                              ]),
                              _: 1
                            }, 8, ["onClick"]))
                          : _createCommentVNode("", true)
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true)
              ])
            ]))
      ])
    ]),
    _createVNode(_component_el_dialog, {
      "destroy-on-close": "",
      modelValue: _ctx.showTicketAddTag,
      "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.showTicketAddTag = $event)),
      "custom-class": "ticket-add-tag-dialog",
      "show-close": false,
      width: "681px"
    }, {
      default: _withId(() => [
        _createVNode(_component_TicketAddTag, {
          "checked-tags": _ctx.ticket.fields.extraTags,
          cancel: () => _ctx.showTicketAddTag = false,
          submit: _ctx.onSubmit
        }, null, 8, ["checked-tags", "cancel", "submit"])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    (_ctx.detialShowTickets)
      ? (_openBlock(), _createBlock("div", _hoisted_108, [
          _createVNode("div", _hoisted_109, [
            _hoisted_110,
            _createVNode("i", {
              onClick: _cache[21] || (_cache[21] = ($event: any) => {_ctx.detialShowTickets = false; _ctx.relationJiraBtn = false}),
              class: "el-icon-close"
            })
          ]),
          _createVNode("div", _hoisted_111, [
            _hoisted_112,
            _hoisted_113,
            _createVNode(_component_el_select, {
              modelValue: _ctx.jiraProject,
              "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.jiraProject = $event)),
              placeholder: "请选择",
              filterable: ""
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.jiraProjectList, (item, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.name,
                    key: i
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_114, [
            _hoisted_115,
            _hoisted_116,
            _createVNode(_component_el_select, {
              modelValue: _ctx.errorEnv,
              "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.errorEnv = $event)),
              placeholder: "请选择",
              filterable: ""
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errorEnvList, (item, i) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    label: item.name,
                    value: item.name,
                    key: i
                  }, null, 8, ["label", "value"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          (_ctx.contJiraType === 'relation')
            ? (_openBlock(), _createBlock("div", _hoisted_117, [
                _hoisted_118,
                _hoisted_119,
                _createVNode(_component_el_select, {
                  modelValue: _ctx.handlerJira,
                  "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.handlerJira = $event)),
                  placeholder: "请选择",
                  filterable: ""
                }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.jiraHandlers, (p) => {
                      return (_openBlock(), _createBlock(_component_el_option, {
                        key: p.id,
                        value: p.ldap,
                        label: p.name
                      }, null, 8, ["value", "label"]))
                    }), 128))
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (_ctx.showChangeTemplate)
      ? (_openBlock(), _createBlock(_component_TicketTemplateChange, {
          key: 1,
          show: _ctx.showChangeTemplate,
          "onUpdate:show": _cache[25] || (_cache[25] = ($event: any) => (_ctx.showChangeTemplate = $event)),
          "ticket-id": Number(_ctx.$route.params.id),
          "relation-map": _ctx.currentTemplateInfo?.template?.fields?.relationMap,
          value: _ctx.currentTemplateInfo?.fieldInfo,
          "current-template-id": Number(_ctx.currentTemplateInfo.template?.pk),
          onUpdate: _ctx.loadTicketDetail
        }, null, 8, ["show", "ticket-id", "relation-map", "value", "current-template-id", "onUpdate"]))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_120, [
      _createVNode(_component_el_dialog, {
        modelValue: _ctx.showPhaseSelectDialog,
        "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.showPhaseSelectDialog = $event)),
        width: "364px"
      }, {
        default: _withId(() => [
          _hoisted_121,
          _createVNode("div", _hoisted_122, [
            _hoisted_123,
            _createVNode(_component_el_select, {
              modelValue: _ctx.selectedPhase,
              "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.selectedPhase = $event))
            }, {
              default: _withId(() => [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.claimablePhases, (phase) => {
                  return (_openBlock(), _createBlock(_component_el_option, {
                    key: phase.phaseId,
                    value: phase.phaseId,
                    label: phase.phaseName
                  }, null, 8, ["value", "label"]))
                }), 128))
              ]),
              _: 1
            }, 8, ["modelValue"])
          ]),
          _createVNode("div", _hoisted_124, [
            _createVNode("div", {
              class: "cancel-button",
              onClick: _cache[27] || (_cache[27] = ($event: any) => (_ctx.showPhaseSelectDialog = false))
            }, "取 消"),
            _createVNode("div", {
              class: "confirm-button",
              onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.assignWithPhase && _ctx.assignWithPhase(...args)))
            }, "确 定")
          ])
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createVNode(_component_el_dialog, {
      title: _ctx.workflowName,
      modelValue: _ctx.previewDialogVisible,
      "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.previewDialogVisible = $event))
    }, {
      default: _withId(() => [
        _createVNode(_component_el_image, {
          style: {"width":"100%"},
          src: _ctx.workflowDiagram,
          "preview-src-list": _ctx.workflowDiagramList
        }, null, 8, ["src", "preview-src-list"])
      ]),
      _: 1
    }, 8, ["title", "modelValue"])
  ]))
})